module.exports = __webpack_public_path__ + "static/media/orderDetailsWeightIcon.3d70b36f.svg";